import {useEffect, useRef} from "react";
import {useSetState} from "ahooks";
import {SListTabs} from "shj-components";

import TableList from "./list.tsx";
import {
  getTicketsChannelConfig, getTicketsExposureConfig,
  getTicketsExternalConfig,
  getTicketsInternalConfig, getTicketsSolutionConfig,
  ticketsChannelConfigAdd,
  ticketsChannelConfigUpdate, ticketsExposureConfigAdd, ticketsExposureConfigUpdate,
  ticketsExternalConfigAdd,
  ticketsExternalConfigUpdate,
  ticketsInternalConfigAdd,
  ticketsInternalConfigUpdate, ticketsSolutionConfigAdd, ticketsSolutionConfigUpdate
} from "@/services/customerServices.ts";

const PriceStrategy = () => {
  const listRef = useRef()

  const apiUrlObj = {
    Internal: { // 对内分类
      getPage: getTicketsInternalConfig,
      add: ticketsInternalConfigAdd,
      updateById: ticketsInternalConfigUpdate,
    },
    External: { // 对外分类
      getPage: getTicketsExternalConfig,
      add: ticketsExternalConfigAdd,
      updateById: ticketsExternalConfigUpdate,
    },
    Channel: { // 渠道
      getPage: getTicketsChannelConfig,
      add: ticketsChannelConfigAdd,
      updateById: ticketsChannelConfigUpdate,
    },
    Exposure: { // 曝光渠道
      getPage: getTicketsExposureConfig,
      add: ticketsExposureConfigAdd,
      updateById: ticketsExposureConfigUpdate,
    },
    Solution: { // 解决方案
      getPage: getTicketsSolutionConfig,
      add: ticketsSolutionConfigAdd,
      updateById: ticketsSolutionConfigUpdate,
    },

  }

  const [state, setState] = useSetState<any>(
      {
        activeKey: '',
        tabs: [],
      })

  useEffect(() => {
    getTabs()
  }, []);

  useEffect(() => {
    listRef.current?.reload()
  }, [state.activeKey]);

  const getTabs = async () => {
    // const tabList = await getProductEnums('com.shj.saas.plus.product.enums.PriceMngTypeEnum');
    const tabs = [
      {key: 'Internal', label: '对内分类', description: '分类'},
      {key: 'External', label: '对外分类', description: '分类'},
      {key: 'Channel', label: '渠道', description: '渠道'},
      {key: 'Exposure', label: '曝光渠道', description: '渠道'},
      {key: 'Solution', label: '解决方案', description: '分类'},
    ].map(item => {
      return {
        ...item,
        children: <TableList key={item.key} apiUrlObj={apiUrlObj[item.key]} current={item}/>
      }
    })
    setState({tabs, activeKey: tabs[0]?.key})
  }

  return (
      <div>
        <SListTabs auth={false}
                   items={state.tabs}
                   activeKey={state.activeKey}
                   onChange={(key: string) => setState({activeKey: key})}
                   hideExtra={false}/>

      </div>
  );
};

export default PriceStrategy;